import AuthenticationService from 'service/auth/AuthenticationService';
import EnvironmentService from 'service/environment/EnvironmentService';
import APIConfig from 'service/network/APIConfig';
import APIService from 'service/network/APIService';

class ChecklistMasterService {
  constructor() {
    this.authenticationService = new AuthenticationService();
    this.environmentService = new EnvironmentService();
    this.apiService = new APIService();
  }

  new(checklistMaster, onResponse, onError) {
    let url = APIConfig.checklistMaster.new;

    return this.apiService.post(url, checklistMaster, onResponse, onError);
  }

  get(id, onResponse, onError) {
    let url = APIConfig.checklistMaster.get.format(id);

    return this.apiService.get(url, onResponse, onError);
  }

  getAll(onResponse, onError) {
    let url = APIConfig.checklistMaster.getAll;

    return this.apiService.get(url, onResponse, onError);
  }

  update(id, checklistMaster, onResponse, onError) {
    let url = APIConfig.checklistMaster.update.format(id);

    return this.apiService.put(url, checklistMaster, onResponse, onError);
  }
}

export default ChecklistMasterService;
